import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Papa from "papaparse";
import { useEffect, useState } from "react";
import { api, superAdminReqConfig } from "../../include/api";
import "../../styles/Super.css";
import SuperAdminHeader from "./Header";

const ServiceItemReport = () => {
    const [fetchLoading, setFetchLoading] = useState(true);
    const [serviceItemData, setServiceItemData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const getShopedProducts = (afterGet) => {
        setFetchLoading(true);
        api.get('/sold_service_details/', superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setServiceItemData(response.data.data);
                setFilteredData(response.data.data);
                if (afterGet) afterGet(response.data.data);
            }
        }).catch(error => {
            setServiceItemData([]);
            setFilteredData([]);
            if (afterGet) afterGet([]);
        }).finally(() => setFetchLoading(false));
    };

    useEffect(() => {
        getShopedProducts();
    }, []);

    // Function to handle filtering by date range
    const handleFilter = () => {
        const from = new Date(fromDate);
        const to = new Date(toDate);

        const filtered = serviceItemData.filter((item) => {
            const soldDate = new Date(item.date);
            return soldDate >= from && soldDate <= to;
        });

        setFilteredData(filtered);
    };

    // Handle Search Filter
    const handleSearch = (query) => {
        setSearchQuery(query);

        const filtered = serviceItemData.filter((data) => {
            return (
                data.serviceId?.toString().toLowerCase().includes(query?.toLowerCase()) ||
                data.serviceName?.toLowerCase().includes(query?.toLowerCase())
            );
        });

        setFilteredData(filtered);
    };

    // PDF Download
    const downloadPDF = () => {
        const doc = new jsPDF();
        const title = "Service Orders Report";

        doc.setFontSize(18);

        const pageWidth = doc.internal.pageSize.getWidth();
        const titleWidth = doc.getTextWidth(title);
        const titleX = (pageWidth - titleWidth) / 2;

        doc.text(title, titleX, 10);
        autoTable(doc, {
            head: [['S.No', 'Service Id', 'Service Name', 'Count', 'Total Amount', 'Last Date']],
            body: filteredData.map((item, i) => [
                i + 1,
                item.serviceId,
                item.serviceName,
                item.totalQty,
                item.totalAmount,
                item.date
            ])
        });
        doc.save('service_orders.pdf');
    };

    // CSV Download
    const downloadCSV = () => {
        const csvData = filteredData.map((item, i) => ({
            'S.No': i + 1,
            'Service Id': item.serviceId,
            'Servicr Name': item.serviceName,
            'Count': item.totalQty,
            'Total Amount': item.totalAmount,
            'Last Date': item.date
        }));

        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'service_orders.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <SuperAdminHeader>
            <div className="fixed-top-bar">
                <div className="card">
                    <h5 className="m-2">Service Items Report</h5>
                    <div className="card-body">

                        {/* Date Filters */}
                        <div className="filter-section shadow p-2 rounded">
                            <div className="row d-flex">
                                <div className="date-filter col-lg-4 col-sm-6 col-xl-4">
                                    <label>From Date:</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>
                                <div className="date-filter col-lg-4 col-sm-6 col-xl-4">
                                    <label>To Date:</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                </div>
                                <div className="mt-2 col-lg-4 col-sm-6 col-xl-4">
                                    <button className="mx-2 my-3 btn btn-primary" onClick={handleFilter}>
                                        Apply Filter
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row ">
                            <div className="search-section m-3 col-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Product ID or Product Name"
                                    value={searchQuery}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                            <div className="col m-3">
                                <button
                                    className="btn btn-success mx-2"
                                    onClick={downloadPDF}
                                    style={{ fontSize: "14px" }}
                                >
                                    <i class="fa-solid fa-download"></i> PDF
                                </button>
                                <button
                                    className="btn btn-success mx-2"
                                    onClick={downloadCSV}
                                    style={{ fontSize: "14px" }}
                                >
                                    <i class="fa-solid fa-download"></i> CSV
                                </button>
                            </div>
                        </div>

                        {/* Items Table */}
                        <div className="table-wrapper">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Service Order Id</th>
                                        <th>Order Date</th>
                                        <th>Payment Mode</th>
                                        <th>Status</th>
                                        <th>Service ID</th>
                                        <th>Service Name</th>
                                        <th>Count</th>
                                        <th>Total Amount</th>
                                        {/* <th>Last Date</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData?.map((item, index) => (
                                        <tr key={item.serviceId}>
                                            <td>{index + 1}</td>
                                            <td>{item.orderId}</td>
                                            <td>{item.date}</td>
                                            <td>{item.paymentMode}</td>
                                            <td>{item.status}</td>
                                            <td>{item.serviceId}</td>
                                            <td>{item.serviceName}</td>
                                            <td>{item.totalQty}</td>
                                            <td>{item.totalAmount.toFixed(2)}</td>
                                            {/* <td>{item.date}</td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </SuperAdminHeader>
    );
};

export default ServiceItemReport;
